import React from 'react';

export const WaveFold = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 88.4 88.4"
      {...props}
    >
      <defs>
        <circle id="prefix__a" cx={44.2} cy={44.2} r={43.5} />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g
        clipPath="url(#prefix__b)"
        stroke="#233762"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      >
        <path
          d="M89.4 25.9h-.1c-1.1 0-2.8-1-3.9-2.3S83.9 21 81.5 21s-2.8 1.2-3.9 2.6c-.8 1-2 2.3-3 2.3-1-.1-2.2-1.3-3-2.3-1.1-1.3-1.5-2.6-3.9-2.6s-2.8 1.2-3.9 2.6c-1.1 1.3-2.8 2.3-3.9 2.3s-2.8-1-3.9-2.3c-1.1-1.3-1.5-2.6-3.9-2.6s-2.8 1.2-3.9 2.6c-1.1 1.3-2.8 2.3-3.9 2.3s-2.8-1-3.9-2.3c-1.1-1.3-1.5-2.6-3.9-2.6s-2.8 1.2-3.9 2.6c-1.1 1.3-2.8 2.3-3.9 2.3s-2.8-1-3.9-2.3c-1.1-1.3-1.5-2.6-3.9-2.6s-2.8 1.2-3.9 2.6c-1 1.3-2.6 2.3-3.7 2.3s-2.7-1.1-3.7-2.3C8.5 22.3 8.1 21 5.7 21s-2.8 1.2-3.9 2.6c-.5.6-1.1 1.9-1.7 2.1v75.7s.3 2.9 3.5 2.9H90.3V25.9z"
          fill="#96b0bb"
        />
        <path fill="none" d="M74.4 25.8v78.4" />
        <path
          fill="#96b0bb"
          d="M59.5 25.9v78.3M43.7 25.9v78.3M27.9 25.9v78.3M12.4 25.9v78.3"
        />
      </g>
      <circle
        cx={44.2}
        cy={44.2}
        r={43.5}
        fill="none"
        stroke="#233762"
        strokeWidth={1.449}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
      />
    </svg>
  );
};
